export const hasFinancialDraftDelegation = (behavior: string, hasPermission: boolean): boolean =>
  hasPermission && ['COMPANY_ADMIN', 'COMPANY_GROUP_ADMIN', 'OPERATOR', 'SHORE'].includes(behavior)

/** A broad grant alone must not expose a Draft outside the server's checked row scope. */
export const canAccessFinancialDraft = (options: {
  isSuperAdmin: boolean
  isOfficeRole: boolean
  hasDelegation: boolean
  rowEligible?: boolean
}): boolean => options.isSuperAdmin || !options.isOfficeRole ||
  (options.hasDelegation && options.rowEligible === true)
